import {
  DEFAULT_PHYSICS_PRESET_ID,
  getPhysicsPreset,
  isPhysicsPresetId,
  type PhysicsPreset,
  type PhysicsPresetId,
} from '../core/config';
import {
  DEFAULT_VISUAL_PRESET_ID,
  getVisualPreset,
  isVisualPresetId,
  type VisualPreset,
  type VisualPresetId,
} from '../rendering/visual-presets';

export interface InvalidPresetRequest {
  readonly parameter: 'physics' | 'visual';
  readonly requested: string;
  readonly fallback: string;
}

export interface SessionConfig {
  readonly physicsId: PhysicsPresetId;
  readonly visualId: VisualPresetId;
  readonly physics: PhysicsPreset;
  readonly visual: VisualPreset;
  readonly debugEnabled: boolean;
  readonly labEnabled: boolean;
  readonly invalidRequests: readonly InvalidPresetRequest[];
}

export function resolveSessionConfig(search: string): SessionConfig {
  const parameters = new URLSearchParams(search);
  const requestedPhysics = parameters.get('physics');
  const requestedVisual = parameters.get('visual');
  const invalidRequests: InvalidPresetRequest[] = [];

  if (requestedPhysics !== null && !isPhysicsPresetId(requestedPhysics)) {
    invalidRequests.push({
      parameter: 'physics',
      requested: requestedPhysics,
      fallback: DEFAULT_PHYSICS_PRESET_ID,
    });
  }
  if (requestedVisual !== null && !isVisualPresetId(requestedVisual)) {
    invalidRequests.push({
      parameter: 'visual',
      requested: requestedVisual,
      fallback: DEFAULT_VISUAL_PRESET_ID,
    });
  }

  const physics = getPhysicsPreset(requestedPhysics);
  const visual = getVisualPreset(requestedVisual);
  return Object.freeze({
    physicsId: physics.id,
    visualId: visual.id,
    physics,
    visual,
    debugEnabled: parameters.get('debug') === '1',
    labEnabled: parameters.get('lab') === '1',
    invalidRequests,
  });
}
